import { AnimatePresence, m } from 'framer-motion'; // Use 'm' for optimized imports
import { useVisibility } from 'src/context/visibility-context';
import ListPageView from './list-view';
import Map from './map';

export default function MapPageView() {
  const { showMapAndList } = useVisibility();
  return showMapAndList ? (
    <AnimatePresence>
      <m.div
        style={{ width: '100%' }} // Use 'm.div' instead of 'motion.div'
        key="list-view" // Ensures that the component is correctly identified by Framer Motion
        initial={{ opacity: 0, scale: 0.95 }} // Start state (hidden, slightly scaled down)
        animate={{ opacity: 1, scale: 1 }} // End state (fully visible and normal scale)
        exit={{ opacity: 0, scale: 0.95 }} // Exit state (hidden, slightly scaled down)
        transition={{
          duration: 0.5, // Animation duration for both entry and exit
          ease: 'easeInOut', // Ease type for the transition
        }}
      >
        <ListPageView />
      </m.div>
    </AnimatePresence>
  ) : (
    <Map />
  );
}
